import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Button } from '@piplapps/pipl-ui';
import LoadingButton from '../../../Components/LoadingButton/index';
import styles from './DisableTeamManagementModal.module.less';
import AnalyticsEventNames from '../../../Utils/AnalyticsHandler/AnalyticsEventNames';
import AnalyticsHandler from '../../../Utils/AnalyticsHandler/AnalyticsHandler';
import { AppActions } from '../../../Redux/modules/app/actions';

const DisableTeamManagementModal = (props) => {
  return (
    <div className={styles.modalContainer}>
      <div className={styles.header}>Disable Team Management</div>
      <span
        tabIndex={0}
        role="button"
        className={styles.close}
        onClick={() => {
          props.clickedCloseModalButton();
        }}
      >
        &times;
      </span>
      <div className={styles.text}>
        <strong>{gettext('Are you sure you want to disable team management?')}</strong>
        <div>
          {gettext(
            'Performing this action, all users will be unassigned from their team, and all teams will be deleted.',
          )}
        </div>
      </div>
      <div className={styles.buttonContainer}>
        <div className={styles.buttonWrapper}>
          <AnalyticsHandler eventName={AnalyticsEventNames.DISABLE_TEAM_MANAGEMENT}>
            <LoadingButton
              buttonClass="primary-red"
              id="submit-button"
              type="submit"
              loadingText={gettext('Disabling')}
              text={gettext('Disable')}
              onClick={() => props.onDisableTeamManagement()}
            />
          </AnalyticsHandler>
        </div>
        <div className={styles.buttonWrapper}>
          <Button
            buttonClass="secondary-blue"
            id="cancel-button"
            onClick={() => props.clickedCloseModalButton()}
            text={gettext('Cancel')}
          />
        </div>
      </div>
    </div>
  );
};

DisableTeamManagementModal.propTypes = {
  clickedCloseModalButton: PropTypes.func,
  onDisableTeamManagement: PropTypes.func,
};

const mapDispatchToProps = {
  onDisableTeamManagement: AppActions.disableTeamManagement,
};

export default connect(null, mapDispatchToProps)(DisableTeamManagementModal);
